export class BNLTextArea {
	init() {
		const textareas = document.querySelectorAll("textarea");

		textareas.forEach(textarea => {
			// Force textarea elements to be at least the height of the scroll bar.
			// This is most useful for readonly textareas so they show all their content.
			textarea.style.minHeight = `${textarea.scrollHeight}px`;

			// Do this if we decide we want to have the textareas grow as content is entered.
			// textarea.addEventListener("input", () => {
			// textarea.style.minHeight = `${textarea.scrollHeight}px`;
			// });
		});
	}
}
document.addEventListener("DOMContentLoaded", () => {
	const textarea = new BNLTextArea();
	textarea.init();
});
